// extracted by mini-css-extract-plugin
module.exports = {"works":"Works_works__3G6mO","gallery":"Works_gallery__1eDoM"};